export const SEARCH_PAGE_BREAKPOINTS = {
  XS: 469,
  SM: 620,
  MD: 908,
  LG: 1123,
  XL: 1441,
  XXL: 2060,
};

export const SMALLER_SCREEN_BREAKPOINT = 975;
export const NUMBER_OF_SEARCH_RESULTS_PER_PAGE = "40";

export const DEFAULT_PAGE = "0";
export const DEFAULT_SEARCH_LANGUAGE = "en";

export const SORT_BY_RELEVANCE_FILTER_OPTION = {
  label: "Most Relevant",
  value: "relevance",
};

export const DEFAULT_SEARCH_SORT_BY = SORT_BY_RELEVANCE_FILTER_OPTION.value;

export const SORT_BY_FILTER_OPTIONS = [
  SORT_BY_RELEVANCE_FILTER_OPTION,
  { label: "Most Recent", value: "recency" },
];

export const LANGUAGE_FILTER_ENGLISH_OPTION = {
  label: "English",
  value: "en",
  isSelected: true,
  dataQaSelector: "filter-search-by-english-language",
};

export const LANGUAGE_FILTER_SPANISH_OPTION = {
  label: "Español",
  value: "es",
  isSelected: false,
  dataQaSelector: "filter-search-by-spanish-language",
};

export const LANGUAGE_FILTER_OPTIONS = [
  LANGUAGE_FILTER_ENGLISH_OPTION,
  LANGUAGE_FILTER_SPANISH_OPTION,
];

export enum ContentTypes {
  articleheader = "articleheader",
  audiotrack = "audiotrack",
  externallink = "externallink",
  interactivevideolink = "interactivevideolink",
  textset = "textset",
  standard = "standard",
  video = "video",
}

export enum Grades {
  GRADE_1 = "Grade 1",
  GRADE_2 = "Grade 2",
  GRADE_3 = "Grade 3",
  GRADE_4 = "Grade 4",
  GRADE_5 = "Grade 5",
  GRADE_6 = "Grade 6",
  GRADE_7 = "Grade 7",
  GRADE_8 = "Grade 8",
  GRADE_9 = "Grade 9",
  GRADE_10 = "Grade 10",
  GRADE_11 = "Grade 11",
  GRADE_12 = "Grade 12",
  Kindergarten = "Grade K",
}

export const URL_PARAMS = {
  page: "page",
  needle: "needle",
  sortBy: "sort_by",
  gradeGroups: "grade_groups",
  contentTypes: "content_types",
  staticResultsId: "static_results_id",
  adminContentSettings: "admin_content_settings",
  consetGroupIds: "conset_group_ids",
};

export const SEARCH_PARAMS = {
  video: "video",
  language: "language",
  audioTrack: "audiotrack",
  articleHeader: "articleheader",
  readingSkills: "reading_skills",
  lexileLevelRange: "lexile_level_range",
  interactiveVideoLink: "interactivevideolink",
  instructionalFeatures: "instructional_features",
};

export type LexileLevelsTypes =
  | 60
  | 120
  | 180
  | 240
  | 300
  | 360
  | 420
  | 480
  | 540
  | 600
  | 660
  | 720
  | 780
  | 840
  | 900
  | 960
  | 1020
  | 1080
  | 1140
  | 1200
  | 1260;

export const LEXILE_GRADE_MAP = {
  60: {
    grade: "K",
    lexile: 60,
  },
  120: {
    grade: 1,
    lexile: 120,
  },
  180: {
    grade: 1,
    lexile: 180,
  },
  240: {
    grade: 1,
    lexile: 240,
  },
  300: {
    grade: 2,
    lexile: 300,
  },
  360: {
    grade: 2,
    lexile: 360,
  },
  420: {
    grade: 2,
    lexile: 420,
  },
  480: {
    grade: 2,
    lexile: 480,
  },
  540: {
    grade: 3,
    lexile: 540,
  },
  600: {
    grade: 3,
    lexile: 600,
  },
  660: {
    grade: 4,
    lexile: 660,
  },
  720: {
    grade: 4,
    lexile: 720,
  },
  780: {
    grade: 5,
    lexile: 780,
  },
  840: {
    grade: 5,
    lexile: 840,
  },
  900: {
    grade: 5,
    lexile: 900,
  },
  960: {
    grade: 6,
    lexile: 960,
  },
  1020: {
    grade: 7,
    lexile: 1020,
  },
  1080: {
    grade: 7,
    lexile: 1080,
  },
  1140: {
    grade: 8,
    lexile: 1140,
  },
  1200: {
    grade: "9-10",
    lexile: 1200,
  },
  1260: {
    grade: "11-12",
    lexile: 1260,
  },
};
